<template>
    <div class="register-modal">
        <div class="modal">
            <div class="content animated slideInDown">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row center-xs separate">
                            <div class="col-xs-12 col-md-10">
                                <img src="@/assets/imgs/modal-registro.png" alt="" class="img-responsive m">
                            </div>
                        </div>
                        <h1 class="title text-center m">Quiero ser un Guardián por la Seguridad Vial</h1>
                        <h1 class="title text-center m">Fecha de nacimiento</h1>
                        <form action="">
                            <div class="row separate">
                                <div class="col-xs-12 col-md-4">
                                    <select name="" v-model="info.day" required m>
                                        <option value="0" selected disabled>Día</option>
                                        <option :value="e" v-for="e in 31" v-text="e"></option>
                                    </select>
                                </div>
                                <div class="col-xs-12 col-md-4">
                                    <select name="" v-model="info.month" required m>
                                        <option value="0" selected disabled>Mes</option>
                                        <option :value="i+1" v-for="(month, i) in months" v-text="month"></option>
                                    </select>
                                </div>
                                <div class="col-xs-12 col-md-4">
                                    <select name="" id="" v-model="info.year" required m>
                                        <option value="0" selected disabled>Año</option>
                                        <option value="2000">2000</option>
                                        <option value="2001">2001</option>
                                        <option value="2002">2002</option>
                                        <option value="2003">2003</option>
                                        <option value="2004">2004</option>
                                        <option value="2005">2005</option>
                                        <option value="2006">2006</option>
                                        <option value="2007">2007</option>
                                        <option value="2008">2008</option>
                                        <option value="2009">2009</option>
                                        <option value="2010">2010</option>
                                        <option value="2011">2011</option>
                                        <option value="2012">2012</option>
                                        <option value="2013">2013</option>
                                        <option value="2014">2014</option>
                                        <option value="2015">2015</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row center-xs">
                                <div class="col-xs-12 col-md-6">
                                    <button type="button" class="btn-primary m" @click="save($event)" data-gender="GIRL">
                                        Soy Niña
                                    </button>
                                </div>
                                <div class="col-xs-12 col-md-6">
                                    <button type="button" class="btn-primary m" @click="save($event)" data-gender="BOY">
                                        Soy Niño
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row center-xs list">
                    <div class="col-xs-4 col-md-2"><img src="@/assets/imgs/logos/FIA.png"></div>
                    <div class="col-xs-4 col-md-2"><img src="@/assets/imgs/logos/OMDAI.png"></div>
                    <div class="col-xs-4 col-md-2"><img src="@/assets/imgs/logos/FCS.png"></div>
                    <div class="col-xs-4 col-md-2"><img src="@/assets/imgs/logos/PILOTOS.png"></div>
                    <div class="col-xs-4 col-md-2"><img src="@/assets/imgs/logos/NISSAN.png"></div>
                    <div class="col-xs-4 col-md-2"><img src="@/assets/imgs/logos/CRUZ-ROJA.png"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from 'sweetalert'

    export default {
        name: 'register-form-component',
        data() {
            return {
                months: [
                    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ],
                info: {
                    day: 0,
                    month: 0,
                    year: 0,
                    gender: ''
                }
            }
        },
        methods: {
            save(evt) {
                this.info.gender = evt.target.dataset.gender
                console.log('Gender', this.info.gender)
                if (!this.isEmptyInfo()) {
                    swal('Alerta', 'Selecciona tu edad completa', 'warning')
                } else {
                    swal({
                        title: 'ESPERA POR FAVOR',
                        text: ' ',
                        icon: 'info',
                        closeOnClickOutside: false,
                        showConfirmButton: false,
                        closeOnEsc: false,
                        buttons: false
                    });
                    this.axios.post('addKid', this.info)
                        .then(res => {
                            localStorage.setItem('api_token', res.data.token);
                            this.$store.commit('token', res.data.token);
                            swal.close();
                            this.$router.push({path: '/'});
                            this.$root.$emit('video:init');
                        })
                        .catch(err => {
                            console.error(err);
                            swal('Error', 'Registro no exitoso', 'error');
                        })
                }
            },
            isEmptyInfo() {
                let pass = true
                Object.keys(this.info)
                    .forEach(e => {
                        console.log(this.info[e])
                        if (!this.info[e]) {
                            pass = false
                        }
                    });
                return pass
            }
        }
    };
</script>

<style lang="sass" scoped>
    .register-modal
        height: 100%
        width: 100%
        position: relative
        .m
            margin: 7.5px
        input, select, .btn-primary
            height: 45px
            font-size: 25px
            margin: 7.5px
            box-sizing: border-box
            @media only screen and (max-width: 47.9em)
                height: 40px !important
        .btn-primary
            height: 40px !important
            font-size: 25px
        .modal
            padding: 25px 15px
            background-color: aliceblue
            position: absolute
            top: 50%
            left: 50%
            max-width: 90%
            max-height: 90%
            overflow-y: auto
            transform: translate(-50%, -50%)
            border-radius: 10px
            width: 65%
            height: auto
            box-sizing: border-box
            @media only screen and (max-width: 64em)
                width: 90%

        .title
            color: #747474
            margin: 0 0 8px 0
            @media only screen and (max-width: 47.9em)
                font-size: .8em !important
        .list
            margin-top: 10px
            @extend .m
            img
                height: auto
                max-height: 70px
                width: auto
                max-width: 100%

</style>
